<app-daily-battery-usage-report
	[columnsTooltips]="{
		used_batteries_count: 'tooltip.battlinkDevice.site_used_devices_count_column',
		usage_score: 'tooltip.battlinkDevice.site_usage_utilization_score_column',
		energy_usage_score: 'tooltip.battlinkDevice.site_energy_utilization_score_column',
	}"
	[currentSite]="siteInfo"
></app-daily-battery-usage-report>
<app-monthly-quarterly-battery-usage-report></app-monthly-quarterly-battery-usage-report>
<app-daily-monthly-quarterly-battery-usage-charts [currentSite]="siteInfo"></app-daily-monthly-quarterly-battery-usage-charts>



<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<div class="d-flex justify-content-between align-items-center">
				<h4>
					{{ 'fleet_reports.battery_performance_charts' | translate}}
				</h4>
				<div class="d-inline-flex ml-auto">
					<button  class="btn fa fa-print fa-lg"  printTitle="{{'g.performance' | translate}}" [useExistingCss]="true" printSectionId="battery_performance_charts" ngxPrint title="{{'g.print' | translate}}"></button>
					<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
				</div>
			</div>

			<!-- date filter -->
			<div class="row col-xl-12 mb-4 mt-5">
				<div class="col-xl-3 col-md-6">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text">{{'g.start_date' | translate}}</span>
						</div>
						<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
						<div class="input-group-append pointer" (click)="d1.toggle()">
							<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						</div>
					</div>
				</div>

				<div class="col-xl-3 col-md-6">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text">{{'g.end_date' | translate}}</span>
						</div>
						<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
						<div class="input-group-append pointer" (click)="d2.toggle()">
							<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						</div>
					</div>
				</div>
			</div>

			<div class="row col-xl-12 mb-4">
				<div class="col-xl-3 col-md-6">
					<!-- voltage filter -->
					<label for="warning">{{'fleet_reports.battery_voltage' | translate}}</label>
					<ng-select
						[(ngModel)]="selectedBatteryVoltage"
						[items]="batteryVoltagesOptions"
						name="tags_filter"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
					></ng-select>
				</div>
				<div class="col-xl-3 col-md-6">
					<!-- capacity filter -->
					<label for="warning">{{'devices.battery_capacity' | translate}}</label>
					<ng-select
						[(ngModel)]="selectedBatteryCapacity"
						[items]="batteryCapacitiesOptions"
						name="tags_filter"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
					></ng-select>
				</div>

				<!-- Manufacturer filter -->
				<div class="col-xl-3 col-md-6">
					<label for="battery_manufacturer">{{"devices.battery_manufacturer" | translate}}</label>
					<ng-select
						class="select"
						[(ngModel)]="selectedBatteryManufacturer"
						[items]="batteryManufacturersOptions"
						bindLabel="label"
						bindValue="value"
						[placeholder]="'devices.battery_manufacturer' | translate"
					></ng-select>
				</div>

				<!-- Vintage filter -->
				<div class="col-xl-3 col-md-6">
					<label for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
					<ng-select
						name="batteryVintageSelect"
						id="batteryVintageSelect"
						class="select"
						[multiple]="true"
						[items]="vintageOptionsDropdown"
						[addTag]="true"
						[clearable]="false"
						[searchable]="false"
						bindLabel="label"
						bindValue="value"
						[placeholder]="'devices.battery_vintage' | translate"
						[(ngModel)]="selectedBatteryVintage"
						(change)="batteryVintageSelectionChanged()"
					>
						<ng-template ng-label-tmp let-item="item" let-clear="clear">
							<span>
								<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
								<span class="ng-value-label">{{item.label}}</span>
							</span>
						</ng-template>
					</ng-select>
				</div>
			</div>

			<div id="battery_performance_charts">
				<app-print-filters title="fleet_reports.battery_performance_charts" [filters]="printFilters"></app-print-filters>
				<app-end-voltage-chart
					[event_type]="'inuse'"
					[userParentFilters]="true"
					[fromDate]="fromDate"
					[toDate]="toDate"
					[selectedBatteryVoltage]="selectedBatteryVoltage"
					[selectedBatteryCapacity]="selectedBatteryCapacity"
					[selectedBatteryVintage]="selectedBatteryVintage"
					[selectedBatteryManufacturer]="selectedBatteryManufacturer"
					(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
					(chartDataReady)="onChartDataReady('inuse_end_voltage', $event)"
				></app-end-voltage-chart>
				<app-end-voltage-chart
					[event_type]="'charge'"
					[userParentFilters]="true"
					[fromDate]="fromDate"
					[toDate]="toDate"
					[selectedBatteryVoltage]="selectedBatteryVoltage"
					[selectedBatteryCapacity]="selectedBatteryCapacity"
					[selectedBatteryVintage]="selectedBatteryVintage"
					[selectedBatteryManufacturer]="selectedBatteryManufacturer"
					(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
					(chartDataReady)="onChartDataReady('charge_end_voltage', $event)"
				></app-end-voltage-chart>
				<app-distribution-chart
					[title]="'fleet_reports.battery_soc_percent' | translate"
					[chartType]="'BatterySOCDistribution'"
					[fromDate]="fromDate"
					[toDate]="toDate"
					[selectedBatteryVoltage]="selectedBatteryVoltage"
					[selectedBatteryCapacity]="selectedBatteryCapacity"
					[selectedBatteryVintage]="selectedBatteryVintage"
					[selectedBatteryManufacturer]="selectedBatteryManufacturer"
					(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
					(chartDataReady)="onChartDataReady('soc_distribution', $event)"
				></app-distribution-chart>
				<app-distribution-chart
					[title]="'fleet_reports.battery_charging_temperature' | translate"
					[chartType]="'BatteryChargingTempDistribution'"
					[fromDate]="fromDate"
					[toDate]="toDate"
					[selectedBatteryVoltage]="selectedBatteryVoltage"
					[selectedBatteryCapacity]="selectedBatteryCapacity"
					[selectedBatteryVintage]="selectedBatteryVintage"
					[selectedBatteryManufacturer]="selectedBatteryManufacturer"
					(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
					(chartDataReady)="onChartDataReady('charging_temp_distribution', $event)"
				></app-distribution-chart>
				<app-distribution-chart
					[title]="'fleet_reports.battery_inuse_temperature' | translate"
					[chartType]="'BatteryInUseTempDistribution'"
					[fromDate]="fromDate"
					[toDate]="toDate"
					[selectedBatteryVoltage]="selectedBatteryVoltage"
					[selectedBatteryCapacity]="selectedBatteryCapacity"
					[selectedBatteryVintage]="selectedBatteryVintage"
					[selectedBatteryManufacturer]="selectedBatteryManufacturer"
					(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
					(chartDataReady)="onChartDataReady('inuse_temp_distribution', $event)"
				></app-distribution-chart>
				<app-distribution-chart
					[title]="'fleet_reports.battery_plug_ins' | translate"
					[chartType]="'BatteryPlugInDistribution'"
					[fromDate]="fromDate"
					[toDate]="toDate"
					[selectedBatteryVoltage]="selectedBatteryVoltage"
					[selectedBatteryCapacity]="selectedBatteryCapacity"
					[selectedBatteryVintage]="selectedBatteryVintage"
					[selectedBatteryManufacturer]="selectedBatteryManufacturer"
					(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
					(chartDataReady)="onChartDataReady('plug_in_distribution', $event)"
				></app-distribution-chart>
			</div>
		</div>
	</div>
</div>